/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

enum AnalyticsEventName {
    ButtonTap = "via_shift_plan_button_tap",
    ScreenDisplay = "via_shift_plan_screen_display",
    UserAuthentication = "via_shift_plan_user_authentication",
    ApplicationError = "via_shift_plan_application_error",
}

export default AnalyticsEventName;
